import { render, staticRenderFns } from "./credit-policy.vue?vue&type=template&id=2500fb0f&scoped=true&"
import script from "./credit-policy.vue?vue&type=script&lang=js&"
export * from "./credit-policy.vue?vue&type=script&lang=js&"
import style0 from "./credit-policy.vue?vue&type=style&index=0&id=2500fb0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500fb0f",
  null
  
)

export default component.exports